// src/extenders/height-observer.js
var HeightObserver = class extends HTMLElement {
  constructor() {
    super();
    this.target = this;
    this.variableName = "height";
    this.offsetVariableName = null;
    if (this.getAttribute("data-target") !== null) {
      this.target = document.querySelector(this.getAttribute("data-target"));
    }
    if (this.getAttribute("data-variable-name") !== null) {
      this.variableName = this.getAttribute("data-variable-name");
    }
    if (this.getAttribute("data-offset-var-name") !== null) {
      this.offsetVariableName = this.getAttribute("data-offset-var-name");
    }
    if (this.target === null) {
      this.target = this;
    }
  }
  connectedCallback() {
    this._updateHeight();
    window.addEventListener("resize", this._updateHeight.bind(this));
    window.addEventListener("announcement-bar:connected", this._updateHeight.bind(this));
    window.addEventListener("announcement-bar:resized", this._updateHeight.bind(this));
  }
  _updateHeight() {
    let height = this.offsetHeight;
    const offset = this.getBoundingClientRect().top;
    if (this.hasAttribute("data-include-offset")) {
      height += offset;
    }
    this.target.style.setProperty(`--${this.variableName}`, `${height}px`);
    if (this.offsetVariableName !== null) {
      this.target.style.setProperty(`--${this.offsetVariableName}`, `${offset}px`);
    }
  }
};
if (!window.customElements.get("height-observer")) {
  window.customElements.define("height-observer", HeightObserver);
}
